module.exports = __webpack_public_path__ + "img/telemedicina.fea78fd9.png";